import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-filter-sidenav',
  templateUrl: './filter-sidenav.component.html',
  styleUrls: ['./filter-sidenav.component.scss']
})
export class FilterSidenavComponent implements OnInit {

  companylist = [
    {
      name: 'MIND',
      checked: false
    },
    {
      name: 'MSSL',
      checked: false
    },
    {
      name: 'MATE',
      checked: false
    },
    {
      name: 'PKC',
      checked: false
    },
    {
      name: 'All',
      checked: false
    }
  ];
  unitlist = [
    {
      name: 'All',
      checked: false
    },
    {
      name: 'MATE-CH I',
      checked: false
    },
    {
      name: 'MATE-CH III Dom',
      checked: false
    },
    {
      name: 'MATE-Consolidate',
      checked: false
    },
    {
      name: 'MATE-Merit-North',
      checked: false
    }
  ];
  departmentlist = [
    {
      name: 'All',
      checked: false
    },
    {
      name: 'MATE-CH I',
      checked: false
    },
    {
      name: 'MATE-CH III Dom',
      checked: false
    },
    {
      name: 'MATE-Consolidate',
      checked: false
    },
    {
      name: 'MATE-Merit-North',
      checked: false
    }
  ];
  FYlist = [
    {
      name: '2020-21',
      checked: false
    },
    {
      name: '2019-20',
      checked: false
    },
    {
      name: '2018-19',
      checked: false
    },
    {
      name: '2017-18',
      checked: false
    },
    {
      name: '2016-17',
      checked: false
    }
  ];
  calendarlist = [
    {
      name: 'Q1 (1 Apr - 30 Jun)',
      checked: false
    },
    {
      name: 'Q2 (1 July - 30 Sep)',
      checked: false
    },
    {
      name: 'Q3 (1 Oct - 31 Dec)',
      checked: false
    },
    {
      name: 'Q4 (1 Jan - 31 Mar)',
      checked: false
    },
  ];

  @Output() closePanel: EventEmitter<boolean> = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }
  closed() {
    this.closePanel.emit(false);
  }
}
